import { MainButton } from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { Task } from './task'
import { TodoValidationSchema } from './todoEditItem'

export const TaskList = () => {
    const { watch, setValue, getValues } =
        useFormContext<TodoValidationSchema>()

    const tasks = watch('tasks') || [{}]
    // Create a ref to track the last added task index
    const lastAddedIndexRef = useRef<number | null>(null)
    // Initialize tasks if needed
    useEffect(() => {
        const currentTasks = getValues('tasks')
        if (
            !currentTasks ||
            !Array.isArray(currentTasks) ||
            currentTasks.length === 0
        ) {
            setValue('tasks', [{ name: '' }], {
                shouldDirty: false,
            })
        }
    }, [getValues, setValue])
    const addTask = () => {
        const currentTasks = watch(`tasks`) || []
        if (tasks) {
            const newTask = {
                name: '',
            }
            const newTasks = [...currentTasks, newTask]
            setValue('tasks', newTasks, {
                shouldDirty: true,
                shouldTouch: true,
            })
            // Store the index of the newly added task
            lastAddedIndexRef.current = newTasks.length - 1
        }
    }
    const deleteTask = (index: number) => {
        const currentTasks = getValues('tasks')
        // Ensure tasks is always an array
        const tasksArray = Array.isArray(currentTasks) ? currentTasks : []

        if (tasksArray.length > 0) {
            setValue(
                'tasks',
                tasksArray.filter((_, i) => i !== index),
                { shouldDirty: true }
            )
        }
        if (index === 0 && tasks.length === 1) {
            addTask()
        }
    }
    // Check if tasks is a valid array to avoid rendering issues
    const validTasks = Array.isArray(tasks) ? tasks : []

    return (
        <Stack spacing={'0px'}>
            {validTasks.map((_, index) => (
                <Task
                    key={index}
                    onAddTask={addTask}
                    index={index}
                    onDeleteTask={deleteTask}
                    shouldFocus={index === lastAddedIndexRef.current}
                />
            ))}
            <Box height={'16px'}></Box>
            <MainButton onClick={addTask} size="small" icon="Add" />
        </Stack>
    )
}
